import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
// import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
// import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_ResponsivePIXIApp } from "../SlotGameType1_ResponsivePIXIApp";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
// namespace SlotGames {

    export class StickyChilliClassic_ResponsivePIXIApp extends SlotGameType1_ResponsivePIXIApp {


        
        protected override helpFactory: IHelpFactory = new StickyChilliHelpFactory();
        //SEND COLOR 
        protected override color: RewardColor =
            {
                color: "white",
                coloroutherStroke: "black",
                colorinnerStroke: "purple",
            }
        //LED COLOR
		protected override ColorLed:string="255,64,0\n";
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "StickyChilliClassic") {
            super(multigameParams, initData, gameName);

            this.spinnableReelsParams.topBorderWidth = 8;
            this.spinnableReelsParams.bottomBorderWidth = 8;
        }

        // public PrepareFont(resourceManager: ResourceManager) {
        //     resourceManager.Add(new FontResource(this.basepath + "resources/MexicanTequila.ttf", this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
        // }

    }

    //Help Colorized
    class StickyChilliHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new StickyChilliHelp(params);
        }
    }

    class StickyChilliHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(64, 21, 21),rgb(140, 4, 4), rgb(191, 6, 6),rgb(140, 4, 4),rgb(64, 21, 21)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }

// }
